import Navigation from "./Navigation.js";
import BusinessStatus from "./BusinessStatus.js";
import StateTabs from "./StateTabs.js";
import Accordion from "./Accordion.js";
import AwardsAndAffiliations from "./AwardsAndAffiliations.js";
import BeforeAndAfter from "./BeforeAndAfter.js";
import PhoneFormatter from "./PhoneFormatter.js";
import People from "./People.js";
import Slideshow from "./Slideshow.js";
import ProjectStories from "./ProjectStories.js";
import FreeEstimateForm from "./FreeEstimateForm.js";
import FreeEstimatePrefill from "./FreeEstimatePrefill.js";
import FreeEstimateHours from "./FreeEstimateHours.js";
import ImageCarousel from "./ImageCarousel.js";
import ImageGallery from "./ImageGallery.js";
import MobileMenu from "./MobileMenu.js";
import SearchableBlogGrid from "./SearchableBlogGrid.js";
import SearchablePressList from "./SearchablePressList.js";
import SearchableGlobalList from "./SearchableGlobalList.js";
import HeaderSearchPopover from "./HeaderSearchPopover.js";
import MobileSearch from "./MobileSearch.js";
import PromotionalBanner from "./PromotionalBanner.js";
import StickyHeader from "./StickyHeader.js";
import YoutubeVideo from "./YoutubeVideo.js";

const modules = {
  navigation: Navigation,
  businessStatus: BusinessStatus,
  stateTabs: StateTabs,
  accordion: Accordion,
  awardsAndAffiliations: AwardsAndAffiliations,
  beforeAndAfter: BeforeAndAfter,
  phoneFormatter: PhoneFormatter,
  people: People,
  slideshow: Slideshow,
  projectStories: ProjectStories,
  freeEstimateForm: FreeEstimateForm,
  freeEstimatePrefill: FreeEstimatePrefill,
  freeEstimateHours: FreeEstimateHours,
  imageCarousel: ImageCarousel,
  imageGallery: ImageGallery,
  mobileMenu: MobileMenu,
  searchableBlogGrid: SearchableBlogGrid,
  searchablePressList: SearchablePressList,
  searchableGlobalList: SearchableGlobalList,
  headerSearchPopover: HeaderSearchPopover,
  mobileSearch: MobileSearch,
  promotionalBanner: PromotionalBanner,
  stickyHeader: StickyHeader,
  youtubeVideo: YoutubeVideo,
};

export default modules;
